<template>
  <v-dialog
    :value="visible"
    max-width="50rem"
    persistent
    @input="$emit('close')"
  >
    <v-card>
      <v-card-text>
        <h1 class="text-center">
          Šta sad da radim?!
        </h1>
      </v-card-text>

      <v-divider />

      <v-card-text>
        <ol style="font-size: 16px;">
          <li class="mb-2">
            <p class="ma-0 font-weight-bold">
              Korak: Kreiraj kategorije!
            </p>
            <p class="ma-0">
              (možete kreirati neograničen broj kategorija roba i usluga koje nabavljate)
            </p>
          </li>
          <li class="mb-2">
            <p class="ma-0 font-weight-bold">
              Korak: Unesi dobavljače za kreirane kategorije!
            </p>
            <p class="ma-0">
              (možete upisati neograničen broj dobavljača za svaku od kategorija)
            </p>
          </li>
          <li class="mb-2">
            <p class="ma-0 font-weight-bold">
              Korak: Raspiši nabavku!
            </p>
            <p class="ma-0">
              (kreiranjem zahteva za nabavku dobavljači dobijaju sve potrebne informacije da uspešno odgovore na Vaš zahtev)
            </p>
          </li>
          <li class="mb-2">
            <p class="ma-0 font-weight-bold">
              Korak: Odaberi najbolju ponudu!
            </p>
            <p class="ma-0">
              (pregledajte pristigle ponude dobavljača i odaberite najbolju)
            </p>
          </li>
          <li>
            <p class="ma-0 font-weight-bold">
              Kraj!
            </p>
          </li>
        </ol>
      </v-card-text>

      <v-card-text class="d-flex align-center justify-center mb-2">
        <v-img
          :src="appLogo"
          max-height="50px"
          max-width="50px"
          alt="logo"
          contain
          class="me-3"
        />

        <h2 class="text-2xl font-weight-semibold">
          {{ appName }}
        </h2>
      </v-card-text>

      <v-divider />

      <v-card-actions class="d-flex justify-end">
        <v-btn
          color="primary"
          @click="$emit('close')"
        >
          {{ $t('Close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations } from 'vuex'
import themeConfig from '@themeConfig'

export default {
  name: 'DialogWelcomeInstructions',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      appName: themeConfig.app.name,
      appLogo: themeConfig.app.logo,
    }
  },

  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },

  mounted() {
    if (!localStorage.getItem('dialogWelcomeInstructions')) {
      this.setDialogState({ dialogName: 'welcomeInstructionsVisible', value: true })

      localStorage.setItem('dialogWelcomeInstructions', 'true')
    }
  },

  methods: {
    ...mapMutations('ui', ['setDialogState']),
  },
}
</script>
